

























import Vue from "vue";

export default Vue.extend({
  name: "HealthDashboardHeader",
  props: {
    providerLabel: { type: String, required: true },
    actionPending: { type: Boolean, default: false }
  }
});
